import {Routes} from '@angular/router';
import {AdministrationComponent} from './administration.component';
import {EXPERTISE_AREA_ROUTES} from './expertise-areas/expertise-area.routes';
import {ORGANIZATION_TYPE_ROUTES} from './organization-types/organization-type.routes';
import {ORGANIZATION_SUBTYPE_ROUTES} from './organization-subtypes/organization-subtype.routes';
import {STANDARD_TITLE_ROUTES} from './standard-titles/standard-title.routes';
import {StandardTitleComponent} from './standard-titles/standard-title.component';
import {COUNTRY_ROUTES} from './countries/country.routes';
import {CountryComponent} from './countries/country.component';
import {OrganizationSubtypeComponent} from './organization-subtypes/organization-subtype.component';
import {OrganizationTypeComponent} from './organization-types/organization-type.component';
import {ExpertiseAreaComponent} from './expertise-areas/expertise-area.component';

export const ADMINISTRATION_ROUTES: Routes = [
  { path: '', component: AdministrationComponent },
  { path: 'expertise-areas', component: ExpertiseAreaComponent,  children: EXPERTISE_AREA_ROUTES},
  { path: 'standard-title', component: StandardTitleComponent,  children: STANDARD_TITLE_ROUTES},
  { path: 'countries', component: CountryComponent,  children: COUNTRY_ROUTES},
  { path: 'organization-types', component: OrganizationTypeComponent,  children: ORGANIZATION_TYPE_ROUTES},
  { path: 'organization-subtypes', component: OrganizationSubtypeComponent,  children: ORGANIZATION_SUBTYPE_ROUTES}
];
